import { HttpClient } from '@angular/common/http';
import { Injectable, inject, signal } from '@angular/core';

export interface SidebarManhinh {
  manhinh_id: number;
  ma_manhinh: string;
  ten_manhinh: string;
  path_manhinh: string;
  thutu: number;
}

export interface SidebarNhom {
  nhom_id: number;
  ma_nhom: string;
  ten_nhom: string;
  thutu: number;
  manhinh: SidebarManhinh[];
}

export interface SidebarMenu {
  nhom: SidebarNhom[];
}

@Injectable({ providedIn: 'root' })
export class SidebarService {
  private readonly http = inject(HttpClient);

  readonly nhom = signal<SidebarNhom[]>([]);
  readonly loading = signal(false);

  load(nhanvien_id: number): void {
    this.loading.set(true);
    this.http
      .get<SidebarMenu>('/api/sidebar/menu', {
        headers: { 'X-Nhanvien-Id': String(nhanvien_id) },
      })
      .subscribe({
        next: (res) => {
          this.nhom.set(res.nhom);
          this.loading.set(false);
        },
        error: () => {
          this.nhom.set([]);
          this.loading.set(false);
        },
      });
  }

  clear(): void {
    this.nhom.set([]);
  }
}
